<div class="section-element details-header background {{ containerColor }}" [class.mobile]="rwdService.isSmallDevice">
  <div class="icon-box" *ngIf="!rwdService.isSmallDevice">
    <app-avatar *ngIf="icon" [icon]="icon" [maxContainerSize]="80" [maxIconSize]="50" [iconColor]="iconColor"></app-avatar>
    <ng-content select="[custom-icon]"></ng-content>
  </div>

  <div class="title-box flex-row space-between">
    <div>
      <p class="mat-caption font-14">{{ type | uppercase }}</p>
      <h2 class="font-20">{{ header }}</h2>
    </div>
    <button mat-icon-button *ngIf="rwdService.isSmallDevice && showClose" [mat-dialog-close] class="display-inline">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="buttons-box flex-row">
    <ng-content select="[custom-buttons]"></ng-content>
    <a *ngIf="useEdit && onEdit.observers.length" class="edit-button cursor-pointer" (click)="onEdit.emit()">
      <mat-icon color="black" class="font-20">edit</mat-icon> {{ 'button.edit' | loc }}
    </a>
    <button mat-icon-button *ngIf="!rwdService.isSmallDevice && showClose" [mat-dialog-close] class="display-inline">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content-box">
    <ng-content></ng-content>
  </div>
</div>
